import type { RuleGroupType, RuleType } from 'react-querybuilder';

export const fieldValidator = (r: RuleType) => {
  const doesValueExist = !!r.value;
  if (!doesValueExist && r.operator !== 'null' && r.operator !== 'notNull') {
    return false;
  }
  const stringVal = String(r.value);
  if (stringVal.includes(',')) {
    // don't allow for inputs such as "," or "4343,"
    const splitArray = stringVal.split(',');
    let validationResult = true;
    splitArray.forEach((val) => {
      validationResult = validationResult && !!val;
    });
    return validationResult;
  }
  if (r.operator === 'between' && !stringVal.includes(',')) {
    return false;
  }
  return true;
};

export const validateQuery = (query: RuleGroupType) => {
  if (query.rules.length === 0) {
    return false;
  }
  for (const rule of query.rules) {
    if ('value' in rule && !fieldValidator(rule)) {
      return false;
    }
    if ('rules' in rule && !validateQuery(rule)) {
      return false;
    }
  }
  return true;
};
